<template>
  <div>
    <!--基本 start-->
    <div class="main-container">
      <div class="clearfix">
        <div class="boxed boxed-lg boxed-border d-lg-none d-xl-none d-md-block d-sm-block">
          <div class="input-select">
            <select class="form-control" @change="mobileMenuChange" v-model="w___ArticleId">
              <template v-for="(item,index) in preMenuList" v-if="preMenuList.length > 0">
                <optgroup v-if="item.child && item.child.length" :key="index" :label="item.title">
                  <option v-for="(child,index2) in item.child" :value="child.id" :key="index2">{{child.display}}</option>
                </optgroup>
                <option v-else :value="item.id || ''" :key="index">{{item.title}}</option>
              </template>
            </select>
          </div>
        </div>
        <!--右侧内容 start-->
        <div class="right-content-wrap">
          <div class="right-content">
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
              <v-card class="q-mt-lg article-detail-container card-container no-shadow">
                <v-card-title class="article-title">
                  {{articleData.title || '&nbsp;'}}
                </v-card-title>
                <v-card-text class="article-content" v-html="articleData.content"></v-card-text>
              </v-card>
            </transition>
          </div>
        </div>
        <!--右侧内容 end-->

        <!--FIXME 只有放后面，才能生效？-->
        <!--左侧菜单-PC模式 start-->
        <aside class="left-menu gt-md d-lg-block d-xl-block d-md-none d-sm-none">
          <h2 class="page-caption">{{$t('header.helpCenter')}}</h2>
          <!--左侧菜单-->
          <CTree v-for="(nextConf, index) in preMenuList" :conf="nextConf" :treeConf="preMenuConf" :key="index"/>
        </aside>
        <!--左侧菜单-PC模式 end-->

      </div>
    </div>
    <!--基本 end-->

    <!--侧滑菜单-手机模式 start-->
    <!--<q-layout-drawer
      v-if="showLeftDrawer"
      v-model="leftDrawerShow"
      :width="280"
      side="left"
      class="left-drawer-menu">
      <h2 class="page-caption">帮助中心</h2>
      <CollapseMenu :menu-data="preMenuList"></CollapseMenu>
    </q-layout-drawer>-->
    <!--侧滑菜单-手机模式 end-->

  </div>
</template>

<script>
  import { articleApi } from '../../api/announcement/article.module';
  import { indexApi } from '../../api/indexApi';
  import sliderMenuControlMixin from '../../common/mixin/sliderMenuControl';
  import CTree from '@/components/CTree.vue';

  export default {
    name: 'help',
    components: {
      CTree,
      /* 组件 */
    },
    mixins: [sliderMenuControlMixin],
    data() {
      return {
        sliderMenuId: 'help',
        w___ArticleId: null, // 用于查询的【文章ID】
        preMenuList: [],
        preMenuConf: { choseChild: null },

        articleData: {
          category: null, // 'help_center',
          categoryValue: null, // '帮助中心', // 总组别。'帮助中心'
          // 文章内容。
          content: null, // '<p>1、打开网址<strong><u>https</u></strong>://www.mbaex.com 或&nbsp;<u>https</u>://www.mbaex.net&nbsp;首页，点击右上角&ldquo;<strong>简</strong>&nbsp;&rdquo;按钮,选择网页语言。</p>↵<p><img src="https://static.umbapp.com/upload/system/20180402/201804031643006_23Nsb.jpg" alt="" width="100%" height="100%" />&nbsp;</p>↵<p>&nbsp;</p>↵<p>2、点击右上角&ldquo;<strong>注册</strong>&rdquo;按钮。新用户注册可用手机或邮箱注册。&nbsp;</p>↵<p><img src="https://static.umbapp.com/upload/system/20180402/201804031643023_ArGT0.jpg" alt="" width="100%" height="100%" />&nbsp;</p>↵<p>&nbsp;</p>↵<p>一、邮箱注册</p>↵<p>1、输入页面相应信息，阅读并勾选同意《MBAex用户协议》，点击&ldquo;<strong>立即注册</strong>&rdquo;。</p>↵<p><img src="https://static.umbapp.com/upload/system/20180402/201804031643049_dV8Pv.jpg" alt="" width="100%" height="100%" />&nbsp;</p>↵<p>&nbsp;</p>↵<p>2、点击左侧&ldquo;<strong>基本信息</strong>&rdquo;，选择设置&ldquo;<strong>手机验证</strong>&rdquo;（或者&ldquo;谷歌验证码&rdquo;）。</p>↵<p>附：<strong><!-- Not Allowed Attribute Filtered ( target="_blank") --><a href="https://www.mbaex.com/about/index.html?id=64" rel="noopener">谷歌验证码绑定操作指南</a></strong></p>↵<p><img src="https://static.umbapp.com/upload/system/20180402/201804031644012_fMnwK.jpg" alt="" width="100%" height="100%" />&nbsp;</p>↵<p>&nbsp;</p>↵<p>3、选择设置&ldquo;<strong>交易密码</strong>&rdquo;输入并牢记交易密码。</p>↵<p><img src="https://static.umbapp.com/upload/system/20180402/201804031644031_AVPp9.jpg" alt="" width="100%" height="100%" />&nbsp;</p>↵<p>&nbsp;</p>↵<p>&nbsp;</p>↵<p>二、手机注册</p>↵<p>1、选择&ldquo;<strong>手机注册</strong>&rdquo;，输入页面相应信息，阅读并勾选同意《MBAex用户协议》，点击&ldquo;<strong>立即注册</strong>&rdquo;。</p>↵<p><img src="https://static.umbapp.com/upload/system/20180402/201804031645015_fQs1Z.jpg" alt="" width="100%" height="100%" />&nbsp;</p>↵<p>&nbsp;</p>↵<p>2、点击左侧&ldquo;<strong>基本信息</strong>&rdquo;，选择设置&ldquo;<strong>交易密码</strong>&rdquo;输入并牢记交易密码。</p>↵<p><img src="https://static.umbapp.com/upload/system/20180402/201804031645023_wFT1S.jpg" alt="" width="100%" height="100%" /></p>↵<p>&nbsp;3、实名认证：附：<strong><!-- Not Allowed Attribute Filtered ( target="_blank") --><a href="https://www.mbaex.com/about/index.html?id=76" rel="noopener">实名认证操作指南</a></strong></p>',
          created: null, // '2018-09-17 10:56:49',
          group: null, // 'guide',
          groupValue: null, // '新手指南', //  父组别。'新手指南'
          id: null, // '5b7e877539ebb40ffacb9025',
          img: null, // 'http://mbaex-test.oss-cn-hongkong.aliyuncs.com/static/1539059640024.jpg',
          lastUpdateTime: null, // '2018-10-09 12:34:09',
          status: null, // 1,
          title: null, // '用户注册', // 文章标题。
          weight: null, // 5,
        },
      };
    },
    computed: {
      // ...mapGetters([ /* 你的Vuex-getter们 */]),
    },
    watch: {
      // TIP 切记，watch里面的最外层声明，不能使用箭头函数。（使用了会报错；反而，不使用不会影响this的使用。）
      // TIP deep属性为true，将会同时监听对象内部值的变化。
      // TIP immediate属性，将会立即以表达式的当前值，触发一次回调。（一般用于，监听props在初始化时传入的数据。）                参考资料：https://cn.vuejs.org/v2/api/#vm-watch
      // TIP 而对于那些由网络请求拿到的异步传入的props，普通的watch，就可以充分地监听到数据。（反而是一开始初始化时就完善的props，需要用immediate属性来监听。）
      // TIP 如果不低于两个属性，则原本的方法，用handler属性，存放。
      '$route': {
        immediate: true, // 初始化时，即触发马上更新。
        handler: function (new_val) {
          this.w___ArticleId = new_val.query.articleId;
          if (this.w___ArticleId) {
            this.get_HelpCenterArticle_detail(this.w___ArticleId); // 接口
          }
        },
      },
    },
    mounted() {
      this.get_HelpCenter_list().then(data => {
        this.preMenuList = data.data;
        let id = this.$route.query.articleId;
        if (id) {
          this.w___ArticleId = id;
        } else {
          this.w___ArticleId = this.getFirstArticle({ children: this.preMenuList });
          this.$router.replace('/help?articleId=' + this.w___ArticleId);
        }
      });
    },
    methods: {
      getFirstArticle(item) {
        if (item.children && item.children.length) return `${item.children[0].child[0].id}`;
        let ret = '';
        if (item.child && item.child) {
          item.child.some(child => (ret = this.getFirstArticle(child)));
        }
        return ret;
      },
      leftDrawerMenuClick() {
        // 点击之后，左侧抽屉，收回。
        this.leftDrawerShow = false;
      },

      // 获取所有【帮助中心】列表。
      get_HelpCenter_list() {
        return indexApi.homeIndex_supportApi.get_helpCenter();
      },

      // 根据编号，获取【帮助中心】文章
      async get_HelpCenterArticle_detail(article_id) {
        let result = await articleApi.getArticleDetail(article_id);
        this.articleData = result.data;
      },

      // 按指定条件，查询文章【列表】。
      async get_Article_list() {
        let result = await articleApi.getArticleList({
          // 参数
        });
      },
      mobileMenuChange(e) {
        this.$router.push(`/help?articleId=${e.currentTarget.value}`);
      },
    },
  };
</script>

<style lang="stylus" type="text/stylus" scoped>
  @import "../../common/styles/mixin/two-column-mixin.styl";
  .article-detail-container{
    border: 1px solid #e6eaf0;
    .article-title{
      box-shadow: 0px 2px 5px 0px rgba(191,193,196,0.22);
    }
    >>>.q-card-title{
      font-weight: 600;
    }
    .article-content{
      padding-top: 20px;
      min-height: 50vh;
    }
  }

</style>
